import React from 'react';
import styles from './styles.module.css';
import { useLayoutContext } from '@/context/LayoutContext';

export default function PriceSection({
  value,
  className = '',
  unit,
  prefix,
}: {
  value?: string | number;
  className?: string;
  unit?: string | null;
  prefix?: string;
}) {
  const { priceSymbol } = useLayoutContext();
  return (
    <div className={`${styles.container} ${className}`}>
      {prefix && prefix}
      <div>{value ? (unit == null ? Number(value)?.toLocaleString() : value) : 0}</div>
      <span>{unit != null ? unit : priceSymbol}</span>
    </div>
  );
}
